@if(isMapLoaded) {
  <google-map
    height="100%"
    width="100%"
    [center]="center"
    [zoom]="zoom"
    [options]="mapOptions"
    (mapInitialized)="onMapInitialized($event)"
    #gmap
  >
  </google-map>
} @else {
  <div class="map-loader-container">
    <div class="spinner"></div>
    <div class="loader-text">Caricamento della mappa in corso...</div>
  </div>
}
